import { EPage } from '@/shared/enum/page.enum'
import type { NavigationGuard } from 'vue-router'

export const generateFolioGuard: NavigationGuard = (to, _from, next) => {
  if (
    !to.query.packId ||
    to.query.packId === '' ||
    !to.query.paymentId ||
    to.query.paymentId === ''
  ) {
    return next({ name: EPage.PACKAGES })
  }
  return next()
}
